import z from 'zod';

export const TUTOR_LANGUAGES = ['de', 'en'] as const;
/** Product default when no language is stored (e.g. missing conversation language). */
export const DEFAULT_TUTOR_LANGUAGE = 'de' satisfies TutorLanguage;
/** When the browser/UI language is neither German nor English, use English. */
export const UNSUPPORTED_LANGUAGE_FALLBACK = 'en' satisfies TutorLanguage;

export type TutorLanguage = (typeof TUTOR_LANGUAGES)[number];

export const tutorLanguageSchema = z.enum(TUTOR_LANGUAGES);

export function mapBrowserLanguageTagToTutorLanguage(languageTag: string): TutorLanguage | undefined {
  const normalized = languageTag.toLowerCase();

  if (normalized.startsWith('de')) {
    return 'de';
  }

  if (normalized.startsWith('en')) {
    return 'en';
  }

  return undefined;
}

export function detectBrowserTutorLanguage(browserLanguages: readonly string[] = []): TutorLanguage {
  for (const languageTag of browserLanguages) {
    const tutorLanguage = mapBrowserLanguageTagToTutorLanguage(languageTag);
    if (tutorLanguage) {
      return tutorLanguage;
    }
  }

  return UNSUPPORTED_LANGUAGE_FALLBACK;
}

export function resolveInitialTutorLanguage(): TutorLanguage {
  if (typeof navigator !== 'undefined') {
    const browserLanguages = navigator.languages.length > 0 ? navigator.languages : [navigator.language];
    return detectBrowserTutorLanguage(browserLanguages);
  }

  return DEFAULT_TUTOR_LANGUAGE;
}
